module.exports = __webpack_public_path__ + "static/media/animal-chimpanzee2.ea8435e9.aac";